// « Signalements » (04/11/2026) : lecture seule des signalements envoyés par le bouton
// « Signaler un problème », réservée aux comptes de l'équipe ExecPro360 (is_superadmin ;
// le serveur refuse les autres). Liste, message et capture d'écran ; le lien de l'e-mail
// (#signalement-N) ouvre directement le signalement N. Aucune action d'écriture ici.
import { useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "../contexts/AuthContext";

const frDateTime = (iso) => (iso ? new Date(`${String(iso).replace(" ", "T")}Z`).toLocaleString("fr-FR", { timeZone: "Europe/Paris", dateStyle: "short", timeStyle: "short" }) : "—");
const hashId = () => { const m = window.location.hash.match(/^#signalement-(\d+)$/); return m ? Number(m[1]) : null; };

function Screenshot({ id }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true, made = null;
    api.problemReports.screenshot(id).then(b => { if (!alive) return; made = URL.createObjectURL(b); setUrl(made); }).catch(e => alive && setError(e.message));
    return () => { alive = false; if (made) URL.revokeObjectURL(made); };
  }, [id]);
  if (error) return <div style={{ color: "#b91c1c", fontSize: 12.5 }}>Capture illisible : {error}</div>;
  return url ? <img src={url} alt={`Capture du signalement n° ${id}`} style={{ maxWidth: "100%", border: "1px solid #e5e7eb", borderRadius: 6 }} /> : <div style={{ fontSize: 12.5 }}>Chargement de la capture…</div>;
}

export default function Signalements() {
  const { user } = useAuth();
  const [list, setList] = useState(null);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(hashId);
  useEffect(() => { if (user?.is_superadmin) api.problemReports.list().then(setList).catch(e => setError(e.message)); }, [user?.is_superadmin]);
  useEffect(() => {
    const onHash = () => { const id = hashId(); if (id) setSelected(id); };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  if (!user?.is_superadmin) {
    return <div style={{ padding: 32, color: "var(--text-muted)" }}>Page réservée à l'équipe ExecPro360.</div>;
  }
  const current = (list || []).find(r => r.id === selected) || null;
  return (
    <div style={{ padding: "24px 28px", maxWidth: 1100, margin: "0 auto" }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 4px" }}>Signalements</h1>
      <div style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 14 }}>
        Signalements envoyés par le bouton « Signaler un problème » (200 derniers). Lecture seule.
      </div>
      {error && <div style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 8, padding: "8px 12px", fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {!list ? (!error && <div>Chargement…</div>) : !list.length ? <div style={{ color: "var(--text-muted)" }}>Aucun signalement.</div> : (
        <div style={{ display: "grid", gridTemplateColumns: current ? "minmax(0, 1fr) minmax(0, 1.2fr)" : "1fr", gap: 16, alignItems: "start" }}>
          <table className="table" style={{ width: "100%", fontSize: 12.5 }}>
            <thead><tr><th style={{ textAlign: "left" }}>N°</th><th style={{ textAlign: "left" }}>Date</th><th style={{ textAlign: "left" }}>Société</th><th style={{ textAlign: "left" }}>Page</th><th>Capture</th></tr></thead>
            <tbody>
              {list.map(r => (
                <tr key={r.id} onClick={() => setSelected(r.id)} style={{ cursor: "pointer", background: r.id === selected ? "var(--bg-secondary)" : undefined }}>
                  <td>{r.id}</td><td>{frDateTime(r.created_at)}</td><td>{r.company || `société ${r.company_id}`}</td><td>{r.page_label || r.page || "—"}</td><td style={{ textAlign: "center" }}>{r.has_screenshot ? "oui" : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {current && (
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 14, background: "var(--bg-card)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8 }}>
                <strong>Signalement n° {current.id}</strong>
                <button className="btn" style={{ fontSize: 11, padding: "2px 8px" }} onClick={() => setSelected(null)}>Fermer</button>
              </div>
              <div style={{ fontSize: 12.5, color: "var(--text-secondary)", margin: "6px 0 10px" }}>
                {current.company || `société ${current.company_id}`} · {current.page_label || current.page || "page inconnue"} · {frDateTime(current.created_at)} · {current.user_name || `utilisateur ${current.user_id}`} · statut : {current.status}
              </div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: 13, background: "var(--bg-secondary)", borderRadius: 6, padding: 10, marginBottom: 10 }}>{current.message}</div>
              {current.has_screenshot ? <Screenshot id={current.id} /> : <div style={{ fontSize: 12.5, color: "var(--text-muted)" }}>Pas de capture d'écran.</div>}
            </div>
          )}
          {selected && !current && <div style={{ color: "var(--text-muted)" }}>Signalement n° {selected} introuvable.</div>}
        </div>
      )}
    </div>
  );
}
